// Source strings. Every other locale falls back to this file per key, so a
// key added here keeps working everywhere before it is translated.
const en = {
  // chrome
  'app.name': 'AI Craft Studio',
  'nav.signIn': 'Sign In',
  'nav.signOut': 'Sign Out',
  'nav.signingIn': 'Signing in…',
  'nav.loading': 'Loading…',
  'nav.backToDashboard': 'Back to Dashboard',
  'nav.back': 'Back',
  'nav.language': 'Language',

  // credits
  'credits.label': 'Credits: {count}',
  'credits.loading': 'Credits: —',
  'credits.buyMore': 'Buy More Credits',
  'credits.tooltipBuy': 'Click to buy more credits',
  'credits.tooltipLoading': 'Loading your credit balance',

  // sign-in
  'auth.title': 'Sign In to Continue',
  'auth.subtitle': 'Sign in with Google to get your free credits and track your usage',
  'auth.google': 'Continue with Google',
  'auth.signOutFailed': 'Could not sign you out. Please try again.',
  'auth.signInFailed': 'Could not sign you in. Please try again.',

  // landing
  'landing.headline': 'Make the photo you didn’t take.',
  'landing.sub': 'Sign in to start. Your first three credits are on us.',
  'landing.note': 'One credit per image, charged only when the image comes back.',

  // dashboard
  'dash.eyebrow': 'Tools',
  'dash.headline': 'Make the photo you didn’t take.',
  'dash.sub': 'Pick a tool. Each one costs a credit, and only when it works.',

  // tools
  'tool.arrow.name': 'Arrow Vision',
  'tool.arrow.transform': 'Map → view',
  'tool.arrow.desc': 'Point an arrow anywhere on the map and see what the view looks like from there.',
  'tool.person.name': 'Person Remover',
  'tool.person.transform': 'Crowd → empty',
  'tool.person.desc': 'Take the strangers out of a photo and keep the place you went to.',
  'tool.clothing.name': 'Clothing Try-On',
  'tool.clothing.transform': 'Outfit → you',
  'tool.clothing.desc': 'Put a garment on yourself before you decide whether to buy it.',

  // upload
  'upload.title': 'Upload Your Image',
  'upload.hint': 'Click to select an image or drag and drop',
  'upload.formats': 'Supported: JPG, PNG, GIF • Max size: 10MB',
  'upload.person': 'Upload Person Photo',
  'upload.clothing': 'Upload Clothing Photo',
  'upload.selectImage': 'Click to select an image',
  'upload.formatsShort': 'JPG, PNG — Max 10MB',
  'upload.tooLarge': 'That image is larger than 10MB. Please choose a smaller one.',
  'upload.notImage': 'That file is not an image. Please choose a JPG or PNG.',

  // actions
  'action.generate': 'Generate',
  'action.generating': 'Generating…',
  'action.download': 'Download',
  'action.share': 'Share',
  'action.delete': 'Delete',
  'action.cancel': 'Cancel',
  'action.tryAgain': 'Try again',
  'action.uploadCustom': 'Upload Custom',
  'action.browseLibrary': 'Browse Library',

  // history
  'history.show': 'Show Recent Images ({count})',
  'history.hide': 'Hide Recent Images',
  'history.empty': 'Nothing here yet. Your generated images will appear here.',

  // generation feedback
  'gen.working': 'Working on your image…',
  'gen.takesTime': 'This usually takes under a minute.',
  'gen.noCredits': 'You’re out of credits. Buy more to keep going.',
  'gen.failed': 'That didn’t work. Your credit was not charged.',
  'gen.blocked': 'The safety filter rejected that photo. Try a different one — your credit was not charged.',

  // payment
  'pay.title': 'Buy Credits',
  'pay.subtitle': 'Credits never expire.',
  'pay.creditsLabel': '{count} Credits',
  'pay.saved': '{amount} saved',
  'pay.pay': 'Pay {amount}',
  'pay.processing': 'Processing…',
  'pay.success': 'Payment complete. Your credits have been added.',
  'pay.failed': 'Payment failed. You have not been charged.',
  'pay.completeTitle': 'Payment complete',
  'pay.completeBody': 'Your credits have been added to your account.',

  // errors and empty routes
  'error.title': 'Something went wrong',
  'error.body': 'The page hit an unexpected error. Reloading usually fixes it.',
  'error.reload': 'Reload the page',
  'notFound.title': 'Page not found',
  'notFound.body': 'That URL doesn’t match anything in the studio.',
  'notFound.home': 'Go to the dashboard',

  // footer
  'footer.privacy': 'Privacy Policy',
};

export default en;
